import api from '@/api/index.js'

const account_mobile_devices = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_MOBILE_DEVICES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_MOBILE_DEVICES: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_MOBILE_DEVICES_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountMobileDevices({commit}, accountID) {
      commit('SET_ACCOUNT_MOBILE_DEVICES_ERROR', null)
      commit('SET_ACCOUNT_MOBILE_DEVICES_LOADING', true)
      return api.get(`accounts/${accountID}/mobile-devices?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_MOBILE_DEVICES', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_MOBILE_DEVICES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_mobile_devices
